import { Controller } from '@hotwired/stimulus'
import consumer from '../channels/consumer'

export default class extends Controller {
  static targets = ['button', 'generatingText']
  static values = {
    id: Number
  }

  disconnect() {
    if (this.subscription) {
      consumer.subscriptions.remove(this.subscription)
    }
  }

  _received(data) {
    if (data.status === 'success') {
      window.location.reload();
    }
  }

  generateIban(e) {
    e.preventDefault();

    this.buttonTarget.classList.add('d-none');
    this.generatingTextTarget.classList.remove('d-none');

    this.subscription = consumer.subscriptions.create(
      {
        channel: 'Wallets::IbanChannel',
        profile_id: this.idValue
      },
      {
        received: this._received.bind(this),
      }
    );
  }
}
